import React from "react";

import useUniqueId from "components/useUniqueId";

import IconBox from "../IconBox";

export type FlagIconProps = {
  color?: string;
  /**
   * True if the icon is purely decorative (doesn't add information about content on the page)
   */
  decorative?: boolean;
  /**
   * Label for the icon. Only set if there is no existing element that labels it
   */
  label?: string;
  /**
   * Id of the element that labels this icon
   */
  labelledById?: string;
  /**
   * Width and height of the icon in pixels
   */
  iconSize?: number;
};

const EditIcon: React.FC<FlagIconProps> = props => {
  const { color, decorative, label, iconSize } = props;
  const labelledBy = useUniqueId();
  const title = label && <title id={labelledBy}>{label}</title>;
  const svgSize = `${iconSize ?? 22}px`;

  return (
    <IconBox>
      <svg
        aria-hidden={decorative}
        aria-labelledby={labelledBy}
        width={svgSize}
        height={svgSize}
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{title}</title>
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinejoin="round"
        >
          <g
            transform="translate(-391.000000, -2763.000000)"
            stroke={color ?? "currentColor"}
            strokeWidth="2"
          >
            <g transform="translate(0.000000, 2670.000000)">
              <g transform="translate(392.000000, 94.000000)">
                <g>
                  <line
                    x1="9"
                    y1="18"
                    x2="18"
                    y2="18"
                    id="Path"
                    strokeLinecap="round"
                  />
                  <path
                    d="M13.5,1.5 C14.0358984,0.964101615 14.8169873,0.754809472 15.5490381,0.950961894 C16.2810889,1.14711432 16.8528857,1.71891109 17.0490381,2.45096189 C17.2451905,3.1830127 17.0358984,3.96410162 16.5,4.5 L4,17 L0,18 L1,14 L13.5,1.5 Z"
                    id="Path"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </IconBox>
  );
};

export default EditIcon;
